var map = {
	"./assustado.png": 5407,
	"./falando.png": 8397,
	"./falando2.png": 891,
	"./falando_feliz.png": 6712,
	"./falando_feliz2.png": 1016,
	"./feliz.png": 6305,
	"./normal.png": 2025,
	"./sorriso.png": 5211,
	"./sorriso2.png": 8913,
	"./triste.png": 1091
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8077;